<template>
    <div>
        {{ seasons }}
        <h2 class="text-danger" v-if="movie.response.videos.length ==0">No Videos</h2>
        <vs-button v-if="movie.response.videos.length !=0" @click="pushToOld()">add To Old</vs-button>
    </div>
</template>
<script>
export default {
    props:['movie','videos'],
    data() {
        return {
            seasons:[]
        }
    },
    created() {
        this.fetchSeasons();
    },
    methods: {
    
        pushToOld() {
            const movie=this.movie.response;
            console.log(movie)
            const media = [
                {
                    url: movie.poster,
                    type: "image",
                    formats: "jpg",
                },
            ];

            if (movie.kind == 1) {
                for (let index = 0; index < movie.videos.length; index++) {
                    const video = movie.videos[index];
                    media.push({
                    url: video.filename,
                    type: "video",
                    formats: "mp4",
                });
                }
              

                for (let index = 0; index < movie.subtitles.length; index++) {
                    const subtitle = movie.subtitles[index];
                    media.push({
                    url:subtitle.file,
                    type: "subtitle",
                    formats:subtitle.extention,
                });
                }

               
            }

            const data = {
                name: movie.en_title,
                released_at: movie.year,
                plot: movie.ar_plot,
                rating: movie.rating,
                imdb: movie.imdb,
                genres: movie.genres ? movie.genres.map((genre) => ({ name:genre.en_name })) : [],
                cast: movie.crew ? movie.crew.map((cast) => ({ name:cast.name })) : [],
                type: movie.kind == 1 ? "m" : "s",
                media,
                seasons:[]
            };
            console.log(data);
            this.axios.post(`http://172.18.0.224/api/titles/`, data, { headers: { Authorization: "Token d86ead99bf9f3490049e8f1281b2b6fd47747530" } }).then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Movie Addedd To Old 1001nights',
                    text: '',
                    position: 'bottom-center'
                })

            }).catch(errors => {

                this.$vs.notify({
                    color: 'danger',
                    title: 'Error Movie not added to old 1001nights',
                    text: '',
                    position: 'bottom-center'
                })
            });
        }
    },
}
</script>